export default __webpack_public_path__ + "static/media/report-fail.56adddaa.svg";